import { render, staticRenderFns } from "./AgendaEventDisplay.vue?vue&type=template&id=7a853d6c"
import script from "./AgendaEventDisplay.vue?vue&type=script&lang=js"
export * from "./AgendaEventDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports